
import { ServiceData } from "@/types/home";
import { defineComponent, SetupContext, PropType } from "vue";
import ServiceTileItem from "./ServiceTileItem.vue";
export default defineComponent({
  components: { ServiceTileItem },
  name: "ServiceTile",
  props: {
    /**
     * 画像を表示するデータ配列
     */
    list: {
      type: Array as PropType<ServiceData[]>,
      default: () => []
    }
  },
  setup(props, context: SetupContext) {
    /**
     * タグ押下を通知する
     */
    const selectUrlItem = (id: number) => {
      context.emit("on-click", id);
    };

    /**
     * レシピリストを取得する
     */
    const getServices = () => {
      return props != null && props.list != null
        ? props.list.slice(0, 4)
        : null;
    };

    return {
      getServices,
      selectUrlItem
    };
  }
});
